import { useSearchParams } from 'react-router-dom';
import { SrLookup } from '../components/SrLookup';

/**
 * /lookup — find a candidate by SmartRecruiters application ID or URL.
 *
 * Also the Chrome-extension reuse surface: the deep-link form
 * `/lookup?sr=<srApplicationId>` pre-fills and auto-submits.
 *
 * Constraints (Epic 33 / US-234 locked design):
 * - Renders cleanly at 600-700px width.
 * - Dark mode from day one.
 * - No dependency on Layout shell — the SrLookup component is shell-agnostic.
 */
export default function LookupPage() {
  const [params] = useSearchParams();
  const presetSr = params.get('sr') ?? undefined;

  return (
    <div className="mx-auto max-w-2xl px-4 py-8">
      <div className="mb-6 text-center">
        <h1 className="text-2xl font-semibold text-gray-900 dark:text-gray-100">
          Find a candidate by SmartRecruiters link
        </h1>
        <p className="mt-2 text-sm text-gray-600 dark:text-gray-400">
          Paste a SmartRecruiters candidate URL or application ID. We'll open the candidate in
          Recruiter Buddy — or fetch them from SmartRecruiters if they're not here yet.
        </p>
      </div>
      <SrLookup variant="page" initialSrId={presetSr} />
    </div>
  );
}
